import { useEffect, useState, useMemo } from "react";
import {
  Container,
  Table,
  Spinner,
  Button,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
//
// API
import axios from "axios";
import { Base_URL } from "../url";

const ViewAdvancePayments = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const orgId = user?.organisationId;
 const resolvedUserId = user?.userId ?? user?.id ?? 0;
  const ready = useMemo(() => Boolean(orgId), [orgId]);

  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchCustomer, setSearchCustomer] = useState("");
  const [approvingId, setApprovingId] = useState(null);

  // Fetch all payments
  const fetchPayments = async () => {
    if (!ready) return;
    setLoading(true);
    try {
      const res = await axios.get(`${Base_URL}/AdvancePayment/id?id=${orgId}`);
      console.log(res.data);
      const data = Array.isArray(res.data) ? res.data : res.data?.data ?? [];
      setPayments(data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch advance payments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, [ready]);

  // Filter by customer
  const filteredPayments = payments.filter((p) =>
    p.customerName?.toLowerCase().includes(searchCustomer.toLowerCase())
  );

    const handleApprove = async (paymentId) => {
    setApprovingId(paymentId);
    console.log(approvingId);
    try {
      await axios.put(`${Base_URL}/advancepayment`, {
        PaymentId: paymentId,
        CreatedBy: String(resolvedUserId),
      });
      toast.success("Payment approved successfully!");
      fetchPayments(); // refresh list
    } catch (err) {
      console.error(err);
      toast.error("Failed to approve payment");
    } finally {
      setApprovingId(null);
    }
  };
  if (!ready) {
    return (
      <div className="main-content expand">
        <div className="loading-overlay">
          <Sample14 />
        </div>
      </div>
    );
  }

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <Row className="mb-3 align-items-center">
          <Col md={6}>
            <h2 className="fields-title">View Advance Payments</h2>
          </Col>
          <Col md={6} className="text-end">
            <Button variant="primary" onClick={() => navigate("/advancepayment")}>
              Add New Payment
            </Button>
          </Col>
        </Row>

        {/* Search by Customer */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Control
              type="text"
              placeholder="Search by Customer Name"
              value={searchCustomer}
              onChange={(e) => setSearchCustomer(e.target.value)}
            />
          </Col>
        </Row>

        {loading ? (
          <div className="text-center mt-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Organisation Id</th>
                <th>Customer Name</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Payment Mode</th>
                <th>Approval Status</th>
                <th>Notes</th>
                <th>Reference</th>
                <th>Created By</th>
                <th>Created On</th>
                <th>Created Time</th>
                   {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {filteredPayments.length > 0 ? (
                filteredPayments.map((p, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{p.organisationId}</td>
                    <td>{p.customerName}</td>
                    <td>{p.descriptionOfSupply ?? p.description}</td>
                    <td>₹ {p.amountReceived
?? p.amount}</td>
                    <td>{p.paymentMode}</td>
                    <td>{p.approval}</td>
                    <td>{p.notes}</td>
                    <td>{p.reference}</td>
                    <td>{p.createdBy}</td>
                    <td>
                      {p.createdOn.split("T")[0]}
                       
                    </td>
                    <td>
                      {p.createdTime.split(".")[0]}
                       
                    </td>
                        {/* <td>
                      {p.Approval === "Yes" ? (
                        <span className="text-success">Approved</span>
                      ) : (
                        <Button
                          size="sm"
                          variant="success"
                          onClick={() => handleApprove(p.paymentId)}
                          disabled={approvingId === p.paymentId}
                        >
                          {approvingId === p.paymentId ? "Approving..." : "Approve"}
                        </Button>
                      )}
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No advance payments found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Container>
    </div>
  );
};

export default ViewAdvancePayments;
